import React, { useState } from 'react';
import { Calendar, MapPin, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

interface StudentTestimonial {
  timestamp: string;
  name: string;
  college: string;
  course: string;
  takeaway: string;
  canFeature: string;
  logo: string;
  logoColor: string;
}

export const StudentTestimonials = () => {
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  const studentTestimonials: StudentTestimonial[] = [
    {
      timestamp: "2025-06-16T22:15:10",
      name: "Kusuma",
      college: "Reva University",
      course: "ECE",
      takeaway: "This session was an eye-opener—it showed us that creating a product isn't just about coding but involves many roles. Grateful to Srikar Sir for sharing this knowledge early in our journey!",
      canFeature: "Yes, with my name and college",
      logo: "R",
      logoColor: "#6B4423"
    },
    {
      timestamp: "2025-06-16T23:42:16",
      name: "Mithun",
      college: "MS Engineering College",
      course: "Engineering",
      takeaway: "This session helped me understand how product requirements are identified and prepared — a crucial step in building successful products.",
      canFeature: "Yes, with my name and college",
      logo: "M",
      logoColor: "#6B4423"
    },
    {
      timestamp: "2025-06-07T11:46:55",
      name: "Gaganashree S",
      college: "MS Engineering College",
      course: "BE",
      takeaway: "Some innovative ideas and a confidence to start something really effective.",
      canFeature: "Yes, with my name and college",
      logo: "M",
      logoColor: "#6B4423"
    },
    {
      timestamp: "2025-06-07T11:55:59",
      name: "HARINI K",
      college: "MS ENGINEERING COLLEGE",
      course: "CSE",
      takeaway: "It was really great work by letting us know what actually the world of Engineers and Engineering looks like in this session. THANK YOU Srikar sir ! Ur session really inspired us and made us think out of the box . I look forward for ur upcoming sessions as many as possible . One's again THANK YOU SIR !",
      canFeature: "Yes, with my name and college",
      logo: "M",
      logoColor: "#6B4423"
    },
    {
      timestamp: "2025-06-07T15:40:57",
      name: "Kusuma H",
      college: "Reva University",
      course: "ECE",
      takeaway: "The Product First session taught me that we don't need to wait until graduation to start projects. Practical experience is as important as theoretical knowledge. With clarity and purpose, we can solve real problems and learn effectively through projects.",
      canFeature: "Yes, with my name and college",
      logo: "R",
      logoColor: "#6B4423"
    },
    {
      timestamp: "2025-06-07T14:38:45",
      name: "Anonymous Student",
      college: "MS Engineering College",
      course: "CSE",
      takeaway: "I wasn't knowing anything about this, but after this session I thought of thinking yaa we can try something good for the sake of people who can use instagram their daily life",
      canFeature: "Yes, but keep it anonymous",
      logo: "M",
      logoColor: "#6B4423"
    }
  ];

  const nextStudentTestimonial = () => {
    setCurrentTestimonialIndex((current) => (current + 1) % studentTestimonials.length);
  };

  const prevStudentTestimonial = () => {
    setCurrentTestimonialIndex((current) => (current - 1 + studentTestimonials.length) % studentTestimonials.length);
  };

  return (
    <section className="py-4 sm:py-6 md:py-8" style={{backgroundColor: '#FAF7F2'}}>
      <div className="container mx-auto px-3 sm:px-4 md:px-6">
        <div className="text-center mb-4 sm:mb-6 md:mb-8">
          <div className="inline-flex items-center px-3 sm:px-4 md:px-4 py-2 md:py-2 bg-white rounded-full shadow-lg border font-bold mb-2 sm:mb-2 md:mb-3" style={{borderColor: '#C4A052', color: '#6B4423'}}>
            <img 
              src="/A2ZAssist%20logo.png" 
              alt="A2Z Assist Logo" 
              className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 mr-2 md:mr-3 object-contain"
            />
            Real Student Impact
          </div>
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-2 sm:mb-3 md:mb-4 px-2" style={{color: '#2C2420'}}>
            Student Voices
          </h2>
          <p className="text-sm sm:text-base md:text-base px-3" style={{color: '#2C2420'}}>
            How Our A2ZCampus™ Workshops Made a Difference in Their Career Journey
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="relative bg-white rounded-3xl shadow-2xl p-3 sm:p-4 md:p-5 lg:p-6 border border-gray-200">
            <div className="absolute top-0 right-0 -mt-2 -mr-2 sm:-mt-3 sm:-mr-3 md:-mt-4 md:-mr-4 rounded-full p-2 sm:p-2 md:p-3 text-white transform rotate-12 shadow-lg" style={{backgroundColor: '#C4A052'}}>
              <Quote className="w-3 h-3 sm:w-3 sm:h-3 md:w-4 md:h-4" />
            </div>
            
            <blockquote className="relative">
              <div className="flex flex-col sm:flex-row items-start sm:items-center mb-2 sm:mb-3 md:mb-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-2xl flex items-center justify-center mb-2 sm:mb-0 sm:mr-2 md:mr-3 shadow-lg flex-shrink-0" style={{backgroundColor: studentTestimonials[currentTestimonialIndex].logoColor}}>
                  <span className="text-white font-bold text-sm sm:text-base md:text-lg">
                    {studentTestimonials[currentTestimonialIndex].logo}
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center text-xs md:text-xs mb-1 md:mb-1" style={{color: '#2C2420'}}>
                    <Calendar className="w-3 h-3 md:w-3 md:h-3 mr-1 md:mr-2 flex-shrink-0" style={{color: '#C4A052'}} />
                    <span className="truncate">{new Date(studentTestimonials[currentTestimonialIndex].timestamp).toLocaleDateString()}</span>
                  </div>
                  <div className="flex items-center text-xs md:text-xs font-medium" style={{color: '#6B4423'}}>
                    <MapPin className="w-3 h-3 md:w-3 md:h-3 mr-1 md:mr-2 flex-shrink-0" style={{color: '#C4A052'}} />
                    <span className="truncate">{studentTestimonials[currentTestimonialIndex].college}</span>
                  </div>
                </div>
              </div>
              
              <p className="text-xs sm:text-sm md:text-base lg:text-lg leading-relaxed mb-2 sm:mb-3 md:mb-4 italic font-medium" style={{color: '#2C2420'}}>
                "{studentTestimonials[currentTestimonialIndex].takeaway}"
              </p>
              
              <footer className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-3">
                <div className="flex items-center">
                  <div className="h-6 w-6 sm:h-8 sm:w-8 md:h-10 md:w-10 rounded-full flex items-center justify-center shadow-lg flex-shrink-0" style={{backgroundColor: '#C4A052'}}>
                    <span className="text-white font-bold text-xs sm:text-sm md:text-base">
                      {studentTestimonials[currentTestimonialIndex].name.charAt(0)}
                    </span>
                  </div>
                  <div className="ml-2 sm:ml-2 md:ml-3 min-w-0 flex-1">
                    <p className="font-semibold text-xs sm:text-sm md:text-base truncate" style={{color: '#2C2420'}}>
                      {studentTestimonials[currentTestimonialIndex].name}
                    </p>
                    <p className="text-xs sm:text-xs md:text-sm truncate" style={{color: '#2C2420'}}>
                      {studentTestimonials[currentTestimonialIndex].course} Student
                    </p>
                  </div>
                </div>
                
                <div className="flex space-x-2 self-end sm:self-auto">
                  <button 
                    onClick={prevStudentTestimonial}
                    className="p-1 md:p-2 rounded-full hover:opacity-80 transition-all duration-300 hover:scale-110 bg-white border-2" 
                    style={{borderColor: '#7A9CB5', color: '#7A9CB5'}}
                    aria-label="Previous testimonial"
                  >
                    <ChevronLeft className="w-3 h-3 sm:w-4 sm:h-4 md:w-4 md:h-4" />
                  </button>
                  <button 
                    onClick={nextStudentTestimonial}
                    className="p-1 md:p-2 rounded-full hover:opacity-80 transition-all duration-300 hover:scale-110 bg-white border-2"
                    style={{borderColor: '#7A9CB5', color: '#7A9CB5'}}
                    aria-label="Next testimonial"
                  >
                    <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4 md:w-4 md:h-4" />
                  </button>
                </div>
              </footer>
            </blockquote>
          </div>
          
          <div className="flex justify-center mt-2 sm:mt-3 md:mt-4 space-x-2">
            {studentTestimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonialIndex(index)}
                className={`w-2 h-2 md:w-2 md:h-2 rounded-full transition-all duration-300 ${
                  index === currentTestimonialIndex 
                    ? 'scale-125' 
                    : 'hover:opacity-80'
                }`}
                style={{backgroundColor: index === currentTestimonialIndex ? '#C4A052' : '#FFFFFF', border: '1px solid #C4A052'}}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};